export default "__VITE_ASSET__BEKE3tI1__"